
import {
  TitleBox,
  Title,
  Subtitle,
  Breakline
} from "./style";

type TitleProps = {
  TitleText: string;
  SubTitleText: string;
  props?: any;
};

  const TitleComponent = ({ TitleText, SubTitleText }: TitleProps) => {

    return (
      <TitleBox>
        <Title>
          {TitleText}
        </Title>
        <Breakline />
        <Subtitle>
          {SubTitleText}
        </Subtitle>
      </TitleBox>

    );
  };

  export default TitleComponent;
